/**
 * 	券关联订单
 */
export default [
    {
      path: '/linkedOrder',
      component: () => import('@/views/linkedOrder/Index.vue'),
      meta: { requiresAuth: true, title: '关联订单', icon: '', role: true },
      children:
        [],
    },
  ];